<div soho-busyindicator
  [text]="' '"
  [displayDelay]="20"
  [overlayOnly]="false"
  [timeToComplete]="this.uiLoadingIndicatorTimeout"
  >
  <div class="lm-list-container lmc">
    <div>
      <span class="card-title">{{title}}</span>
      @if (_showAuditOutOfSyncWarning) {
        <span class="tag is-dismissible hide-focus lpl-yellow-bg" style="margin-left: 5px; margin-bottom: 4px">{{ 'NotAllChangesReplicated' | translate }}</span>
      }
    </div>
    <div class="main-content filterlist-content-area">
      <div soho-datagrid data-automation-id="lm-audit-compare-panel-grid-datagrid"></div>
    </div>
  </div>
</div>
